import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { DrawerContext, Images } from 'utils';
import { navBarStyles } from '../style';
import { leftBarCommonStyle } from './styles';

export const GUIDES_URL = 'https://help.therapylake.com/';

/**
 * Help Center group in the sidebar's bottom utility block.
 *
 * It sits here rather than in `superAdminRouters` because Help Center is not
 * an area of the product — it belongs with Support and Release Notes, below
 * the divider, which is what the design calls for. That also means it cannot
 * reuse `CustomAccordion`: that component reads its sub-items from a
 * hardcoded name→array chain and is styled for the main nav list.
 *
 * "Guides" keeps the behaviour the old flat Help Center button had — it opens
 * the external knowledge base. "Tutorial Videos" is in-app.
 */
export const HelpCenterAccordion = () => {
    const classes = navBarStyles();
    const commonClasses = leftBarCommonStyle();
    const { open, handleDrawerOpenClose } = useContext(DrawerContext);
    const location = useLocation();
    const [expand, setExpand] = useState(false);

    const isOnTutorialVideos = location?.pathname === '/tutorial-videos';

    // Keep the group open while the user is on one of its pages, so the active
    // item is never hidden inside a collapsed accordion.
    useEffect(() => {
        if (isOnTutorialVideos) setExpand(true);
    }, [isOnTutorialVideos]);

    const handleAccordionClick = () => {
        setExpand((prevState) => !prevState);
        // A 64px rail has no room for sub-items — opening the group opens the
        // drawer, same as the main-nav accordions.
        if (!open) {
            handleDrawerOpenClose(true);
        }
    };

    return (
        <div className="router-accordion-box">
            <div className={classes.helpCenterBox} onClick={handleAccordionClick}>
                <button style={{ width: open ? '100%' : 'auto' }} className={classes.helpCenterButton}>
                    <div>
                        {/* Swaps to the blue variant on an active child route, the
                            same way Release Notes swaps its icon. */}
                        <img src={isOnTutorialVideos ? Images.helpIconActive : Images.helpIcon} alt="help center" />
                    </div>
                    {open && (
                        <>
                            <p style={isOnTutorialVideos ? { color: '#347AF0' } : {}}>Help Center</p>
                            <img
                                className={`${commonClasses.accordArrowStyle} ${expand ? 'rotate' : ''}`}
                                style={{ marginLeft: 'auto' }}
                                src={isOnTutorialVideos ? Images.accordArrowBlue : Images.accordArrowBlack}
                                alt="icon"
                            />
                        </>
                    )}
                </button>
            </div>

            <div className={`${commonClasses.sectionsListBoxStyle} ${open && expand ? 'shown' : ''}`}>
                <div>
                    <a
                        href={GUIDES_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', marginLeft: 2 }}
                    >
                        Guides
                    </a>
                    <NavLink
                        to="/tutorial-videos"
                        className={isOnTutorialVideos ? 'active' : ''}
                        style={{ textDecoration: 'none', marginLeft: 2 }}
                    >
                        Tutorial Videos
                    </NavLink>
                </div>
            </div>
        </div>
    );
};
